<div #floatDiv class="submission-form-holder">
	<div class="drag-form-box justify-content" [rlDrag]="floatDiv">
		<div class="flex-end">
			<div class="drag-form-btn">
			<button class="btn btn-clear btn-drag" [tooltip]="'btn.drag' | translate" [rlAria] [rlTabIndex]>
				<span class="sr-only">{{'btn.drag' | translate}}</span>
			</button>
			</div>
		</div>
		<div class="flex-end" *ngIf="closable">
			<!-- <button type="button" (click)="exit()" class="btn btn-icon-only side-edit-mode-btn-close" rlFocusMe id="close-add-new-item" value="{{'sidebar.edit.close.btn' | translate}}" attr.aria-label="{{'sidebar.edit.close.btn' | translate}}" tabindex="0">
				<span>&#x2715;</span>
				<span class="sr-only">{{'general.close' | translate}}</span>
			</button> -->
		</div>
	</div>
	<div class="submission-form editable-content">
	    <ng-content></ng-content>
	</div>
</div>
